module.exports = __webpack_public_path__ + "img/diapositiva-2-4.05fa370a.png";